export const FLAG_GETTING_COMPANY_AREA_RESPONSABLE =
  'FLAG_GETTING_COMPANY_AREA_RESPONSABLE';
export const GET_COMPANY_AREA_RESPONSABLE = 'GET_COMPANY_AREA_RESPONSABLE';
export const CLEAR_COMPANY_AREA_RESPONSABLE = 'CLEAR_COMPANY_AREA_RESPONSABLE';
